import gql from 'graphql-tag';

export const LocationDetails = gql`
  fragment LocationDetails on Location {
    id
    name
    freeform_address
    address_line_1
    address_line_2
    city
    state {
      long_name
      short_name
    }
    country {
      id
      name
      iso
      iso3
    }
    point {
      latitude
      longitude
    }
  }
`;
